import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'General',
  attributeName: 'tagManager',
  fields: [
    {
      attributeName: 'application',
      helpText: 'Application (b-app for blacklabel apps, w-app for whitelabel apps)',
      type: FormInputTypes.SELECT,
      label: 'Application',
      placeholder: 'Please enter to add Application...',
      multiple: false,
      url: 'tagApplicationList',
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'appValue',
      fieldName:'appText',
      asyncSelect: true,
      options:[],
    },
    {
      attributeName: 'type',
      helpText: 'Type of tag',
      type: FormInputTypes.SELECT,
      label: 'Type',
      emptyValue:true,
      placeholder: 'Please enter to select a tag type',
      options: [
        { name: 'Content', value: 'content' },
        { name: 'Room', value: 'room' },
      ],
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },
    {
      attributeName: 'assignment',
      helpText: 'Assignment',
      type: FormInputTypes.SELECT,
      label: 'Assignment',
      placeholder: 'Please enter to select an assignment',
      multiple: false,
      disabledWhenEdit:true,
      url: 'tagmanagerAssignmentList',
      emptyValue:true,
      childField:'category',
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[],
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },
    {
      attributeName: 'category',
      helpText: 'Select a valid category for the app selected, or set All for all the possible configs of the app',
      type: FormInputTypes.SELECT,
      label: 'Category',
      placeholder: 'Please enter to add a valid category',
      multiple: false,
      disabledWhenEdit:true,
      url: 'tagmanagerCategoryList',
      parentField:'assignment',
      enabledWhen:{"field":"app","notValues":['(Empty)']},
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[],
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },
    {
      attributeName: 'name',
      helpText: 'Name of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
      visibleWhen: [
        { field: 'application', notValue: '(Empty)' },
      ],
    },
    {
      attributeName: 'description',
      helpText: 'Description of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Description',
      placeholder: 'Description...',
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Score',
      placeholder: 'Score...',
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },
    {
      attributeName: 'visible',
      helpText: 'This checkbox is for the main display of the tag. If it is set to false, it will not appear on any representation',
      type: FormInputTypes.CHECKBOX,
      label: 'Visible',
      visibleWhen:[{"field":"application","notValue":"(Empty)"}]

    },

  ],
};
